<header class="custom-header">
  <div class="left">
    <div class="mod-logo">
      @if (currentEnvironment) {
        <div class="environment">
          @if (currentEnvironment.icon) {
            <mat-icon>{{ currentEnvironment.icon }}</mat-icon>
          }
          @if (currentEnvironment.type) {
            <div class="environment-name">
              <p class="bold">{{ currentEnvironment.type }}</p>
              @if (currentEnvironment['featurePrefix']) {
                <p class="bold">{{ currentEnvironment['featurePrefix'] }}</p>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
  <coin-user-menu
    [isDeputyAllowed]="false"
    [isProfileAllowed]="false"></coin-user-menu>
  <div class="right">
    @if (updateNotifications.hasUpdates()) {
      <coin-update-notifier></coin-update-notifier>
    }
  </div>
</header>
